var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileImportSolid = function SvgFileImportSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4v24h20v-9h-2v7H8V6h16v7h2V4Zm11.5 7-4.312 4.281L12.5 16l.688.719L17.5 21l1.406-1.406L16.313 17H28v-2H16.313l2.593-2.594Z"
  })));
};
export default SvgFileImportSolid;